import { CSSProperties } from "react";

export const customStylesSelect = (isError: boolean) => ({
  control: (base: CSSProperties, state: any) => ({
    ...base,
    borderColor: isError ? "red" : state.isFocused ? "#2684FF" : "#ccc",
    boxShadow: state.isFocused && !isError ? "0 0 0 1px #2684FF" : "none",
    "&:hover": {
      borderColor: isError ? "red" : "#2684FF",
    },
  }),
});
